import React from 'react';
import { Routes, Route, useNavigate } from "react-router-dom";
import { toast } from 'sonner';
import Tutor from './Tutor';
import AddTutor from './AddTutor';
import ViewTutor from './ViewTutor';
import EditTutor from './EditTutor';

const ProtectedRoute = ({ element, permission, fallbackPath = '/dashboard/staff' }) => {
  const navigate = useNavigate();

  React.useEffect(() => {
    if (!permission) {
      toast.warning("You don't have permission to access this page.");
      navigate(fallbackPath, { replace: true });
    }
  }, [permission, navigate, fallbackPath]);

  return permission ? element : null;
};

const MainTutor = () => {
  const User = JSON.parse(localStorage.getItem("User") || "{}");
  const Permission = User?.userRole?.permissions?.system || {}; // Using 'system' permissions

  return (
    <div className='bg-gray-100 text-gray-900 dark:bg-gray-900 dark:text-white relative'>
      <Routes>
        <Route path='/' element={<Tutor />} />

        <Route
          path='/add-staff'
          element={<ProtectedRoute element={<AddTutor />} permission={Permission.create} />}
        />

        <Route
          path='/view-staff'
          element={<ProtectedRoute element={<ViewTutor />} permission={Permission.read} />}
        />

        <Route
          path='/edit-staff'
          element={<ProtectedRoute element={<EditTutor />} permission={Permission.update} />}
        />
      </Routes>
    </div>
  );
};

export default MainTutor;